/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

/**
 * Roles that must acknowledge a record of this type. At least one.
 */
export enum EventLifecycleRole {
  MANAGER = "MANAGER",
  DEPUTY_MANAGER = "DEPUTY_MANAGER",
  GROUP_ADMIN = "GROUP_ADMIN",
}
